import React, { createContext, useState, useContext, useEffect } from 'react';
import { translations, dateLocales } from '../utils/translations';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('ro');

  useEffect(() => {
    const savedLang = localStorage.getItem('appLanguage');
    if (savedLang && translations[savedLang]) {
      setLanguage(savedLang);
    } else {
      // Try to detect browser language
      const browserLang = navigator.language.split('-')[0];
      if (translations[browserLang]) {
        setLanguage(browserLang);
      }
    }
  }, []);

  const changeLanguage = (langCode) => {
    if (translations[langCode]) {
      setLanguage(langCode);
      localStorage.setItem('appLanguage', langCode);
    }
  };

  const t = (key) => {
    return translations[language][key] || translations['en'][key] || key;
  };

  const getDateLocale = () => {
    return dateLocales[language] || dateLocales['ro'];
  };

  // Helper to get quotes array
  const getQuotes = () => {
    const keys = ['quote1', 'quote2', 'quote3', 'quote4', 'quote5'];
    return keys.map(k => t(k));
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage, t, getDateLocale, getQuotes }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);